var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.same)?_c('v-icon',_vm._g(_vm._b({attrs:{"color":"success","title":"Значения равны"},domProps:{"textContent":_vm._s(`mdi-equal`)}},'v-icon',_vm.$attrs,false),_vm.$listeners)):_c('v-icon',_vm._b({attrs:{"color":"warning","title":"Значения не равны"},domProps:{"textContent":_vm._s(`mdi-not-equal-variant`)}},'v-icon',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }